export const enum RidesOrder {
  DateAsc = 0,
  DateDesc = 1,
}
